import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setPlayerSession, getPlayerSession } from '../session';
import { useT } from '../i18n';

export function Join() {
  const t = useT();
  const [code, setCode] = useState('');
  const [nickname, setNickname] = useState('');
  const navigate = useNavigate();

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const c = code.trim().toUpperCase();
    const n = nickname.trim();
    if (!c || !n) return;
    // Keep the existing playerId if re-joining the same game (avoids a duplicate);
    // a different code starts fresh.
    const prev = getPlayerSession();
    const playerId = prev && prev.code === c ? prev.playerId : undefined;
    setPlayerSession({ code: c, nickname: n, playerId });
    navigate(`/play/${c}`);
  };

  return (
    <div className="card centered">
      <h1>{t('join.title')}</h1>
      <p className="muted">{t('join.subtitle')}</p>
      <form onSubmit={submit} className="stack">
        <label>
          {t('join.code')}
          <input
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            placeholder={t('join.codePlaceholder')}
            maxLength={8}
            autoCapitalize="characters"
            autoCorrect="off"
          />
        </label>
        <label>
          {t('join.nickname')}
          <input
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            placeholder={t('join.namePlaceholder')}
            maxLength={24}
          />
        </label>
        <button type="submit" className="primary" disabled={!code.trim() || !nickname.trim()}>
          {t('join.submit')}
        </button>
      </form>
    </div>
  );
}
